module.exports = __webpack_public_path__ + "static/media/search-location.f6afbbcf.svg";